module.exports = __webpack_public_path__ + "4fe19cccf866ccf9850481ec2350c222.svg";